import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Dropdown, MenuItem } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import InputMask from 'react-input-mask';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import Toggle from 'react-toggle';

import ScheduleGroupStaffs from './Elements/ScheduleGroupStaffs';
import getLocale from '../../i18n/getLocale';

class SchedulePlanningEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      updated: 0,
      errors_listing: false,
      approve: false,
      justification: null,
      id: null,
      schedule_availability_id: null,
      status_str: null,
      status: null,
      aircraft: null,
      base: null,
      date: null,
      available: null,
      interruption_start: null,
      unavailable_reason: null,
      deadline_preview: null,
      flight_following: null,
      flight_following_reason: null,
      flight_following_date: null,
      flight_following_preview: null,
      sigmec_id: null,
      observations: null,
      schedule_initials_select: [],
      captains_select: [],
      copilots_select: [],
      flight_attendants_select: [],
      flight_following_reasons_select: [],
      staffs_sigmec_select: [],
      flight_reports_select: [],
      schedule_groups: [],
      schedule_warnings: [],
      schedule_logs: [],
      modal_alerts: false,
      staff_alerts: {},
      global_alerts: {},
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.updateData = this.updateData.bind(this);
    this.addGroup = this.addGroup.bind(this);
    this.setFinish = this.setFinish.bind(this);
    this.editAvailability = this.editAvailability.bind(this);
    this.warnings = this.warnings.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
    this.approve = this.approve.bind(this);
    this.modalAlerts = this.modalAlerts.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
      change[name] = value;
      this.setState(change);
    } else {
      var value = 0;
      change[name] = value;
      this.setState(change);
    }
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleSelectChangeMulti(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }
  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData(1));
    }
  }

  updateData (responseJson) {
    this.setState({updated: 1}, this.loadData(responseJson));
  }

  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/programacao/info/edicao/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/sigla/modelos');
        if (responseJson.status === 'success') {
          if(responseJson.data.main.extra_crew == 0) {
            self.setState({
              id: responseJson.data.main.id,
              status: responseJson.data.main.status,
              extra_crew: responseJson.data.main.extra_crew,
              status_str: responseJson.data.main.status_str,
              aircraft: responseJson.data.main.aircraft.registration,
              contract: responseJson.data.main.contract.name,
              base: responseJson.data.main.base.name,
              date: responseJson.data.main.date_str,
              available: responseJson.data.availability.available,
              interruption_start: responseJson.data.availability.interruption_start_str,
              unavailable_reason: responseJson.data.availability.reason,
              deadline_preview: responseJson.data.availability.deadline_preview_str,
              schedule_availability_id: responseJson.data.schedule_availability.id,
              flight_following: responseJson.data.schedule_availability.flight_following,
              flight_following_reason: responseJson.data.schedule_availability.flight_following_reason,
              flight_following_date: responseJson.data.schedule_availability.flight_following_date_str,
              flight_following_preview: responseJson.data.schedule_availability.flight_following_preview_str,
              sigmec_id: responseJson.data.schedule_availability.sigmec_id,
              observations: responseJson.data.schedule_availability.observations,
              schedule_initials_select: responseJson.data.schedule_initials_select,
              captains_select: responseJson.data.captains_select,
              copilots_select: responseJson.data.copilots_select,
              flight_attendants_select: responseJson.data.flight_attendants_select,
              flight_following_reasons_select: responseJson.data.flight_following_reasons_select,
              staffs_sigmec_select: responseJson.data.staffs_sigmec_select,
              flight_reports_select: responseJson.data.flight_reports_select,
              schedule_groups: responseJson.data.schedule_groups,
              schedule_warnings: responseJson.data.schedule_warnings,
              schedule_logs: responseJson.data.schedule_logs,
              captain_duties_select: responseJson.data.captain_duties_select,
              pre_select_captain: responseJson.data.pre_select_captain,
              copilot_duties_select: responseJson.data.copilot_duties_select,
              pre_select_copilot: responseJson.data.pre_select_copilot,
              flight_attendant_duties_select: responseJson.data.flight_attendant_duties_select,
              pre_select_flight_attendant: responseJson.data.pre_select_flight_attendant,
            });
            
          } else {
            self.setState({
              id: responseJson.data.main.id,
              status: responseJson.data.main.status,
              status_str: responseJson.data.main.status_str,
              aircraft: null,
              contract: null,
              base: responseJson.data.main.base.name,
              extra_crew: responseJson.data.main.extra_crew,
              date: responseJson.data.main.date_str,
              available: responseJson.data.availability.available,
              interruption_start: responseJson.data.availability.interruption_start_str,
              unavailable_reason: responseJson.data.availability.reason,
              deadline_preview: responseJson.data.availability.deadline_preview_str,
              schedule_availability_id: responseJson.data.schedule_availability.id,
              flight_following: responseJson.data.schedule_availability.flight_following,
              flight_following_reason: responseJson.data.schedule_availability.flight_following_reason,
              flight_following_date: responseJson.data.schedule_availability.flight_following_date_str,
              flight_following_preview: responseJson.data.schedule_availability.flight_following_preview_str,
              sigmec_id: responseJson.data.schedule_availability.sigmec_id,
              observations: responseJson.data.schedule_availability.observations,
              schedule_initials_select: responseJson.data.schedule_initials_select,
              captains_select: responseJson.data.captains_select,
              copilots_select: responseJson.data.copilots_select,
              flight_attendants_select: responseJson.data.flight_attendants_select,
              flight_following_reasons_select: responseJson.data.flight_following_reasons_select,
              staffs_sigmec_select: responseJson.data.staffs_sigmec_select,
              flight_reports_select: responseJson.data.flight_reports_select,
              schedule_groups: responseJson.data.schedule_groups,
              schedule_warnings: responseJson.data.schedule_warnings,
              schedule_logs: responseJson.data.schedule_logs,
              captain_duties_select: responseJson.data.captain_duties_select,
              pre_select_captain: responseJson.data.pre_select_captain,
              copilot_duties_select: responseJson.data.copilot_duties_select,
              pre_select_copilot: responseJson.data.pre_select_copilot,
              flight_attendant_duties_select: responseJson.data.flight_attendant_duties_select,
              pre_select_flight_attendant: responseJson.data.pre_select_flight_attendant,
            });

          }
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (self.state.updated == 1) {
          self.handleAlert(event.message, event.status, 'open');
          self.setState({updated: 0});
        } else {
          self.handleMessage();
        }
      });
    });
  }

  // Fetch salvando a edição
  addGroup(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      schedule_id: this.state.id,
      start: this.state.start,
      finish: this.state.finish,
      schedule_initial_id: this.state.schedule_initial_id,
      flight_report_ids: this.state.flight_report_ids,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/programacao/grupo', { method: 'post', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if(responseJson.status === 'success') {
          self.loadData(responseJson);
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Fetch salvando a edição
  setFinish(event) {
    var data = new Date();
    var day = data.getDate();
    if (day < 10 ) {
      day = '0' + day;
    }
    var month = (data.getMonth()+1);
    if (month < 10 ) {
      month = '0' + month;
    }
    var hours = data.getHours();
    if (hours < 10 ) {
      hours = '0' + hours;
    }
    var minutes = data.getMinutes();
    if (minutes < 10 ) {
      minutes = '0' + minutes;
    }
    var finish = day + '/' + (month) + '/' + data.getFullYear() + ' ' + hours + ':' + minutes;
    this.setState({finish: finish});
  }

  // Fetch salvando a edição
  editAvailability(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.schedule_availability_id,
      flight_following: this.state.flight_following,
      flight_following_reason: this.state.flight_following_reason,
      flight_following_date: this.state.flight_following_date,
      flight_following_preview: this.state.flight_following_preview,
      sigmec_id: this.state.sigmec_id,
      observations: this.state.observations,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/programacao/disponibilidade', { method: 'put', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if(responseJson.status === 'success') {
          self.loadData(responseJson);
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  warnings() {
    var self = this;
    var url = "/escala/programacao/alertas/";
    var header = this.refs.request_api.header('application/json');
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({approve: false, modal_alerts: true});
          self.modalAlerts(responseJson.data);
          self.handleAlert('', '', 'closed');
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      });
    });
  }

  modalAlerts(data) {

    if (data.staff) {
      this.setState({staff_alerts: data.staff});

    }
    if (data.global) {
      this.setState({global_alerts: data.global});
    }

  }

  changeStatus(url) {
    var confirm = this.locale.Escalas.EditarEscalaDiaria.trocarOStatusDaEscala;
    if (window.confirm(confirm)) {
      var datasave = {id: this.props.match.params.id, ignore_warning: false};
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if(responseJson.status === 'validation_error') {
            self.setState({errors_listing: true, errors_messages: responseJson.data});
            self.handleAlert('', '', 'closed');
          } if(responseJson.status === 'warning') {
            self.setState({approve: true, modal_alerts: true});
            self.modalAlerts(responseJson.data);
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          } else {
            self.updateData(responseJson);
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  approve(event) {
    event.preventDefault();
    var confirm = this.locale.Escalas.EditarEscalaDiaria.aprovarEscalaMesmoComAlertasVermelhos;
    if (window.confirm(confirm)) {
      var datasave = {id: this.props.match.params.id, ignore_warning: true, justification: this.state.justification, staff_alerts: this.state.staff_alerts, global_alerts: this.state.global_alerts};
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/programacao/status/aprovada', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if(responseJson.status === 'validation_error') {
            self.setState({errors_listing: true, errors_messages: responseJson.data});
            self.handleAlert('', '', 'closed');
          } else {
            self.setState({errors_listing: responseJson.data.error, errors_messages: responseJson.data.errors});
            self.updateData(responseJson);
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      {(this.state.extra_crew == 0) ? 

        <h3 className="page-title pull-left">{this.locale.Escalas.EditarEscalaDiaria.titulo} - {this.state.aircraft} - {this.state.contract} - {this.state.base} - {this.state.date}</h3>
        :
        <h3 className="page-title pull-left">{this.locale.Escalas.EditarEscalaDiaria.tituloEditarEscalaDiariaTripulacaoExtra} - {this.state.base} - {this.state.date}</h3>
      }
      <div className="grid-buttons pull-right">
        <Link to="/escalas/programacao" className="btn btn-default"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
        <Dropdown id="revisions">
          <Dropdown.Toggle bsStyle={'primary'}>
            <i className="fa fa-fw fa-certificate"></i> {this.state.status_str}
          </Dropdown.Toggle>
            {(this.state.status === 'approved') ?
              <Dropdown.Menu className="super-colors">
                <MenuItem onSelect={this.changeStatus} eventKey={'/escala/programacao/status/rascunho'}>{this.locale.Escalas.EditarEscalaDiaria.botaoProgramacao.TrocarParaRascunho}</MenuItem>
              </Dropdown.Menu>
            :
              <Dropdown.Menu className="super-colors">
                <MenuItem onSelect={this.changeStatus} eventKey={'/escala/programacao/status/aprovada'}>{this.locale.Escalas.EditarEscalaDiaria.botaoProgramacao.TrocarParaAprovada}</MenuItem>
              </Dropdown.Menu>
            }
        </Dropdown>
        <button onClick={() => this.warnings()} className="btn btn-warning button-inline"><i className="fa fa-fw fa-warning"></i>  {this.locale.Escalas.EditarEscalaDiaria.botaoAlertas}</button>
      </div>
      <div className="clearfix"></div>
      {this.state.errors_listing &&
        <div className="alert alert-danger alert-dismissible" role="alert" style={{marginTop: 25}}>
          <button onClick={() => self.setState({ errors_listing: false, errors_messages: [], })} type="button" className="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>{this.locale.Escalas.EditarEscalaDiaria.erros}:</strong>
          {Object.keys(self.state.errors_messages).map(function(k) {
            var message = self.state.errors_messages[k];
            return (
              <p>- {message}</p>
            );
          })}
        </div>
      }


      {(this.state.extra_crew == 0) ? 
        <div>
          <hr/>
          <h3>{this.locale.Escalas.EditarEscalaDiaria.tituloDisponibilidadeDaAeronave}</h3>
          <hr/>
          <form onSubmit={this.editAvailability}>
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>{this.locale.Escalas.EditarEscalaDiaria.formularioDisponibilidadeDaAeronave.Disponivel}?</label>
                  <br/>
                  <Toggle
                    checked={this.state.available}
                    aria-label=''
                    name="flight_following"
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label>{this.locale.Escalas.EditarEscalaDiaria.formularioDisponibilidadeDaAeronave.IndisponivelDesde}:</label>
                  <InputMask value={this.state.interruption_start}  maskChar={null} name="interruption_start" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'interruption_start')} placeholder="" disabled />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label>{this.locale.Escalas.EditarEscalaDiaria.formularioDisponibilidadeDaAeronave.Razao}:</label>
                  <input value={this.state.unavailable_reason} name="unavailable_reason" className="form-control" onChange={this.handleChange.bind(this, 'unavailable_reason')} placeholder="" disabled />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label>{this.locale.Escalas.EditarEscalaDiaria.formularioDisponibilidadeDaAeronave.Previsao}:</label>
                  <InputMask value={this.state.deadline_preview}  maskChar={null} name="deadline_preview" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'deadline_preview')} placeholder="" disabled />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>{this.locale.Escalas.EditarEscalaDiaria.formularioDisponibilidadeDaAeronave.FlightFollowingAnormal}?</label>
                  <br/>
                  <Toggle
                    checked={this.state.flight_following}
                    aria-label=''
                    name="flight_following"
                    onChange={this.handleToggleChange.bind(this, 'flight_following')} />
                </div>
              </div>
              {
                this.state.flight_following ?
                <div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>{this.locale.Escalas.EditarEscalaDiaria.formularioDisponibilidadeDaAeronave.AnormalDesde}:</label>
                      <InputMask value={this.state.flight_following_date}  maskChar={null} name="flight_following_date" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'flight_following_date')} placeholder="" />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>{this.locale.Escalas.EditarEscalaDiaria.formularioDisponibilidadeDaAeronave.Razao}:</label>
                      <Select
                        className=""
                        name="flight_following_reason"
                        value={this.state.flight_following_reason}
                        searchable={true}
                        placeholder={''}
                        onChange={this.handleSelectChange.bind(this, 'flight_following_reason')}
                        options={this.state.flight_following_reasons_select}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>{this.locale.Escalas.EditarEscalaDiaria.formularioDisponibilidadeDaAeronave.Previsao}:</label>
                      <InputMask value={this.state.flight_following_preview}  maskChar={null} name="flight_following_preview" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'flight_following_preview')} placeholder="" />
                    </div>
                  </div>
                </div>
                : ''
              }
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Escalas.EditarEscalaDiaria.formularioDisponibilidadeDaAeronave.InspetorMecanicoResponsavel}:</label>
                  <Select
                    className=""
                    name="sigmec_id"
                    value={this.state.sigmec_id}
                    searchable={true}
                    placeholder={''}
                    onChange={this.handleSelectChange.bind(this, 'sigmec_id')}
                    options={this.state.staffs_sigmec_select}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Escalas.EditarEscalaDiaria.formularioDisponibilidadeDaAeronave.Observacoes}:</label>
                  <input value={this.state.observations} name="observations" className="form-control" onChange={this.handleChange.bind(this, 'observations')} placeholder="" />
                </div>
              </div>
            </div>
            <hr/>
            <div className="row">
              <div className="col-md-12">
                <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.editar}</button>
              </div>
            </div>
          </form>

        </div>
        :
        ''    
      }

      <hr/>
      <h3>{this.locale.Escalas.EditarEscalaDiaria.tituloCriarGrupo}</h3>
      <hr/>
      <form onSubmit={this.addGroup}>
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Escalas.EditarEscalaDiaria.formularioCriarGrupo.HorarioDeApresentacao}:</label>
              <InputMask value={this.state.start}  maskChar={null} name="start" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'start')} placeholder="" required />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Escalas.EditarEscalaDiaria.formularioCriarGrupo.HorarioDeTerminoDaJornada}:</label>
              <InputMask value={this.state.finish}  maskChar={null} name="finish" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'finish')} placeholder="" />
            </div>
          </div>
          <div className="col-md-1">
            <div className="form-group">
              <button type="button" onClick={() => this.setFinish()} className="btn btn-inline btn-default btn-block"><i className="fa fa-fw fa-calendar"></i></button>
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label>{this.locale.Escalas.EditarEscalaDiaria.formularioCriarGrupo.Situacao}:</label>
              <Select
                className="form-field-name"
                name="schedule_initial_id"
                value={this.state.schedule_initial_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'schedule_initial_id')}
                options={this.state.schedule_initials_select}
                required
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Escalas.EditarEscalaDiaria.formularioCriarGrupo.Voos}:</label>
              <Select
                className="form-field-name"
                name="flight_report_ids"
                value={this.state.flight_report_ids}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChangeMulti.bind(this, 'flight_report_ids')}
                options={this.state.flight_reports_select}
                multi={true}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Escalas.EditarEscalaDiaria.formularioCriarGrupo.botaoAdicionarGrupo}</button>
          </div>
        </div>
      </form>
      <hr />
      {Object.keys(self.state.schedule_groups).map(function(k) {
        var sg = self.state.schedule_groups[k];
        var number = parseInt(k) + 1;

        return (
          <div>
            <ScheduleGroupStaffs updateData={self.updateData} updated={self.state.updated} handleAlert={self.handleAlert} captains_select={self.state.captains_select} captain_duties_select={self.state.captain_duties_select} pre_select_captain={self.state.pre_select_captain} copilots_select={self.state.copilots_select} copilot_duties_select={self.state.copilot_duties_select} pre_select_copilot={self.state.pre_select_copilot} schedule_initials_select={self.state.schedule_initials_select} flight_attendants_select={self.state.flight_attendants_select} flight_attendant_duties_select={self.state.flight_attendant_duties_select} pre_select_flight_attendant={self.state.pre_select_flight_attendant} flight_reports_select={self.state.flight_reports_select} schedule_group={sg} number={number} />
          </div>
        );
      })}
      <h3>{this.locale.Escalas.EditarEscalaDiaria.tituloAlertasDeAprovacao}</h3>
      <hr/>
      <div className="table-responsive">
        <table className="table table-bordered table-hover table-striped">
          <thead>
            <tr>
              <th>{this.locale.Escalas.EditarEscalaDiaria.tabelaAlertasDeAprovacao.Mensagem}</th>
              <th>{this.locale.Escalas.EditarEscalaDiaria.tabelaAlertasDeAprovacao.Data}</th>
            </tr>
          </thead>
          <tbody>
          {Object.keys(self.state.schedule_warnings).map(function(k) {
            var srl = self.state.schedule_warnings[k];
            return (
              <tr>
                <td className={"box-alert box-alert-" + srl.color} dangerouslySetInnerHTML={{__html: srl.message}}></td>
                <td className={"box-alert box-alert-" + srl.color}>{srl.created_at_str}</td>
              </tr>
            );
          })}
          </tbody>
        </table>
      </div>
      <hr/>
      <h3 className="page-title">{this.locale.Escalas.EditarEscalaDiaria.tituloLogDeStatus}</h3>
      <hr/>
      <div className="table-responsive">
        <table className="table table-bordered table-hover table-striped">
          <thead>
            <tr>
              <th>{this.locale.Escalas.EditarEscalaDiaria.tabelaLogDeStatus.Usuario}</th>
              <th>{this.locale.Escalas.EditarEscalaDiaria.tabelaLogDeStatus.Acao}</th>
              <th>{this.locale.Escalas.EditarEscalaDiaria.tabelaLogDeStatus.Descricao}</th>
              <th>{this.locale.Escalas.EditarEscalaDiaria.tabelaLogDeStatus.Justificativa}</th>
              <th>{this.locale.Escalas.EditarEscalaDiaria.tabelaLogDeStatus.Data}</th>
            </tr>
          </thead>
          <tbody>
          {Object.keys(self.state.schedule_logs).map(function(k) {
            var srl = self.state.schedule_logs[k];
            return (
              <tr>
                <td>{srl.user_name}</td>
                <td>{srl.action}</td>
                <td>{srl.message}</td>
                <td>{srl.justification}</td>
                <td>{srl.created_at_str}</td>
              </tr>
            );
          })}
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <Modal show={this.state.modal_alerts} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left"><strong>{this.locale.Escalas.EditarEscalaDiaria.tituloAlertas}</strong></h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => this.setState({modal_alerts: false, justification: null, approve: false})}><i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <div>
        {
          Object.keys(self.state.global_alerts).map(function(k) {
            var alert = self.state.global_alerts[k];
            if(Array.isArray(alert)) {
              return(
                <div>
                  {Object.keys(alert).map(function(klert) {
                    var alert2 = alert[klert];
                    if(alert2) {
                      if (alert2.error && alert2.error === 1) {
                        return(
                          <div className={"box-alert box-alert-" + alert2.color}>
                            <div dangerouslySetInnerHTML={{__html: alert2.message}}></div>
                          </div>
                        );
                      }
                    }
                  })}
                </div>
              );
            }
          })
        }
      </div>
      <div>
        {
          Object.keys(self.state.global_alerts).map(function(k) {
            var alert = self.state.global_alerts[k];
            if(alert) {
              if (alert.error && alert.error === 1) {
                return(
                  <div className={"box-alert box-alert-" + alert.color}>
                    <div dangerouslySetInnerHTML={{__html: alert.message}}></div>
                  </div>
                );
              }
            }
          })
        }
      </div>
      <hr/>
      <div>
        {
          Object.keys(self.state.staff_alerts).map(function(nickname) {
            var alerts = self.state.staff_alerts[nickname];
            return(
              <div>
                <h4><strong>{nickname}</strong></h4>
                {Object.keys(alerts).map(function(k) {
                  var alert = alerts[k];
                  if(alert) {
                    if (alert.error === 1) {
                      return(
                        <div className={"box-alert box-alert-" + alert.color}>
                          <div dangerouslySetInnerHTML={{__html: alert.message}}></div>
                        </div>
                      );
                    }
                  }
                })}
                <hr/>
              </div>
            );
          })
        }
      </div>
      {
        (this.state.approve === true) 
          ?
          <form onSubmit={this.approve}>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>{this.locale.Escalas.EditarEscalaDiaria.formularioAlertas.Justificativa}:</label>
                  <textarea style={{ height: 200 }} type="text" name="justification" required className="form-control" value={this.state.justification} onChange={this.handleChange.bind(this, 'justification')} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-certificate"></i> {this.locale.Escalas.EditarEscalaDiaria.formularioAlertas.botaoContinuarAprovacao}</button>
                </div>
              </div>
            </div>
          </form>
          : 
          ''
      }
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => this.setState({modal_alerts: false, justification: null, approve: false})}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default SchedulePlanningEdit;



// WEBPACK FOOTER //
// ./src/Components/Schedules/SchedulePlanningEdit.js